module.exports = __webpack_public_path__ + "static/media/image2.d60d5503.jpeg";